// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"1dee7d25","147":"48198676","210":"be891d50","611":"74a02fee","807":"2e976e1a","900":"bbec8e99","996":"49c52005"}[chunkId] + ".chunk.js";
};